import script from "./editExpressionHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./editExpressionHistory.vue?vue&type=script&setup=true&lang=ts"

import "./editExpressionHistory.vue?vue&type=style&index=0&id=bc3ddd0a&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc3ddd0a"]])

export default __exports__